<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"  class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            
                            <div class="tab-content">
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Proposte di sviluppo</p>
                                    </div>
                                </div>
                                
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="sorting">
                                        </div>
                                    </div>
                                </div>  
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>Domande disponibili</label>
                                            <div v-for=" (questionCheck,index_q) in questions_available" class="row" :key="index_q">
                                                <div class="col-5" v-if="proposalsQuestions[questionCheck.question_survey_id] !== undefined && proposalsQuestions[questionCheck.question_survey_id].question == questionCheck.question_survey_id">
                                                    <input type="checkbox" :value="questionCheck.question_survey_id" :name="'questionSettings[proposalsQuestions]['+questionCheck.question_survey_id+'][question]'" v-model="proposalsQuestions[questionCheck.question_survey_id].question" >
                                                    <label>{{questionCheck.name}}</label>
                                                </div>
                                                <div class="col-5" v-else>
                                                    <input type="checkbox" :value="questionCheck.question_survey_id" :name="'questionSettings[proposalsQuestions]['+questionCheck.question_survey_id+'][question]'" >
                                                    <label>{{questionCheck.name}}</label>
                                                </div>
                                                <div class="col-5" v-if="proposalsQuestions[questionCheck.question_survey_id] !== undefined && proposalsQuestions[questionCheck.question_survey_id].question == questionCheck.question_survey_id">
                                                    <select :name="'questionSettings[proposalsQuestions]['+questionCheck.question_survey_id+'][filter]'" v-model="proposalsQuestions[questionCheck.question_survey_id].filter">
                                                        <option v-for="filter in questionCheck.filter" :value="filter">{{ filter }}</option>
                                                    </select>
                                                </div>
                                                <div class="col-5" v-else>
                                                    <select :name="'questionSettings[proposalsQuestions]['+questionCheck.question_survey_id+'][filter]'" >
                                                        <option v-for="filter in questionCheck.filter" :value="filter">{{ filter }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>Contenuto</label>
                                            
                                            <div class="row">
                                                <div class="col-4">
                                                    <label>Chiave elemento</label>
                                                    <input type="text" v-model="newElementKey" class="form-control rounded">
                                                </div>
                                                <div class="col-4">
                                                    <label>Label</label>
                                                    <input type="text" v-model="newElementLabel" class="form-control rounded">
                                                </div>
                                                <div class="col-4">
                                                    <label>Tipo elemento</label>
                                                    <select v-model="newElementProposals" class="form-control rounded">
                                                        <option value="">---</option>
                                                        <option value="comment">Commento</option>
                                                        <option value="date">Data</option>
                                                        <option value="options">Opzioni</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <div class="col-12">
                                                    <button class="btn btn--green float-right" type="button" @click="addElement(newElementKey,newElementLabel,newElementProposals)">Aggiungi azione proposta</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="alert alert-warning" v-if="!canEditElements">
                                    Non puoi modificare il nome chiave delle proposte di sviluppo, esistono delle schede che usano questo questionario.
                                </div>
                                
                                <div class="form-group">
                                    <label class="font-weight-bold">Struttura proposta di sviluppo</label>
                                  
                                    <div v-for="(element,index) in proposalsElement" :key="index" class="border shadow-sm mb-3 rounded p-3">
                                        <div class="row align-items-center">
                                            <div class="col-4">
                                                <label>Elemento</label>
                                                <input v-model="element.type" class="form-control rounded" type="hidden" :name="'questionSettings[proposalsElement]['+index+'][type]'">
                                                {{element.type}}
                                            </div>
                                            <div class="col-4" v-if="canEditElements">
                                                <label>Nome chiave</label>
                                                <input v-model="element.key" class="form-control rounded" type="text" :name="'questionSettings[proposalsElement]['+index+'][key]'">
                                            </div> 
                                            <div class="col-4" v-else>
                                                <label>Nome chiave</label>
                                                <br>
                                                {{ element.key }}
                                                <input v-model="element.key" type="hidden" :name="'questionSettings[proposalsElement]['+index+'][key]'">
                                            </div>
                                            <div class="col-3">
                                                <label>Label</label>
                                                <input v-model="element.label" class="form-control rounded" type="text" :name="'questionSettings[proposalsElement]['+index+'][label]'">
                                            </div>
                                            
                                            <div class="col-1">
                                                <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteElement(index)"><i class="fas fa-times"></i></button>
                                                
                                            </div>
                                        </div>
                                        <div v-if="element.type == 'options'" class="row mt-2">
                                            <div class="col-4">
                                                
                                            </div>
                                            
                                            <div class="col-4">
                                                <div class="">
                                                    <label>Nuova opzione</label>
                                                    <input type="text" class="form-control rounded mb-2" v-model="newOption">
                                                    <button class="form-control btn btn--green" type="button" @click="addOption(index)">
                                                        Aggiungi opzione
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            <div class="col-4">
                                                <label>Valori selezionabili</label>
                                                <div v-for="(option, index_op) in element.options" class="row align-items-center mb-2" :key="index_op">
                                                    
                                                    <div class="col-10">
                                                        <input class="form-control rounded" type="text" :value="option" :name="'questionSettings[proposalsElement]['+index+'][options]['+index_op+']'">
                                                    </div>
                                                    <div class="col-2">
                                                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="deleteElementOption(index,index_op)"><i class="fas fa-times"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                                
                                
                                
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Limite minimo di proposte</label>
                                            <input class="form-control" type="number" min="0" v-model="limitMin" name="questionSettings[limitMin]">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Limite max di proposte</label>
                                            <input class="form-control" type="number" min="0" v-model="limitMax" name="questionSettings[limitMax]">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            questions_available : [],
            proposalsQuestions : [],
            
            proposalsElement : [],
            
            newElementProposals : null,
            newElementKey : null,
            newElementLabel : null,
            newOption : null,
            limitMax : 0,
            limitMin : 0,
            //default
            title: "Development Proposals",
            active : false,
            canEditElements : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        
        addElement(newElementKey,newElementLabel,newElementProposals){
            if(this.newElementKey == null || this.newElementLabel == null || this.newElementLabel == null){
                return;
            }
            this.proposalsElement.push({
                type: newElementProposals,
                key : newElementKey,
                label : newElementLabel,
                options : []
            });
            
            this.newElementKey = null;
            this.newElementLabel = null;
            this.newElementLabel = null;
        },
        addOption(index_element){
            this.proposalsElement[index_element].options.push(this.newOption);
            
            this.newOption = "";
        },
        
        deleteElement(index){
            Vue.delete(this.proposalsElement,index);
        },
        deleteElementOption(index_element,index_option){
            Vue.delete(this.proposalsElement[index_element].options,index_option);
        },
        
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.questions_available = response.data.questions_available;
                    this.proposalsQuestions = response.data.proposalsQuestions;
                    this.proposalsElement = response.data.proposalsElement;
                    this.limitMax = response.data.limitMax;
                    this.limitMin = response.data.limitMin;
                    this.canEditElements = response.data.canEditElements;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);
                });
            }
        }
        
    }
    
}
</script>

